<template>
  <div class="ProductFeedback">
    <div class="custom_back_header">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        @click="goBack()"
      >
        <g fill="#FFF" fill-rule="evenodd">
          <path
            d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            style="    fill: #000;"
          />
          <path
            d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            style="    fill: #000;"
          />
        </g>
      </svg>
      <h3>({{feedBackCount}}) {{$t('feedback')}}</h3>
    </div>
    <ul class="feedback-list" v-if="ratingList && ratingList.length > 0">
      <li v-for="(rating,index) in ratingList" :key="index">
        <span class="user-img" v-if="rating.xAuthId" @click="openUserProfile(rating.xAuthId)">
            <img :src="rating.profileImage" class="wdth100" alt="dummy" v-if="rating.profileImage" />
          <img src="../../assets/images/dummy.png" class="wdth100" alt="dummy" v-else />
          </span>
          <span class="user-img" v-else>
            <img :src="rating.profileImage" class="wdth100" alt="dummy" v-if="rating.profileImage" />
          <img src="../../assets/images/dummy.png" class="wdth100" alt="dummy" v-else />
          </span>
        <div class="content">
          <h4>
            {{rating.name}}
            <span>{{rating.timeAgo}}</span>
          </h4>
          <span class="star-icon">
            <star-rating
              :read-only="true"
              :increment="0.5"
              :starSize="12"
              active-color="#138808"
              :rating="Number(rating.rating)"
              :show-rating="false"
            ></star-rating>
          </span>
          <span class="user-msg">{{rating.comment}}</span>
          <ul class="image-preview" @click="galleryPopUp(rating.urls)">
            <li v-for="(productImage,index) in rating.urls" :key="index">
              <img :src="productImage" alt />
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <infinite-loading @infinite="getFeedBackList" spinner="circles">
      <template slot="no-more">{{$t('noMoreRecord')}}</template>
    </infinite-loading>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="watermark" />
    </div>
    <div class="prodgallery_wrap" v-if="openProductGallery == true && galleryImageUrl.length">
      <div class="product_Gallery">
        <span class="close_prodgallery" @click="openProductGallery = !openProductGallery">
          <i class="material-icons">close</i>
        </span>
        <div class="swiper-container gallery-top">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(productImage,index) in galleryImageUrl" :key="index">
              <div class="swiper-slide">
                <div v-lazyload class="img_wrapper spinner_wrapper" v-if="productImage">
                  <ImageSpinner class="image_spinner" />
                  <img :data-url="productImage" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next">
            <i class="material-icons">arrow_forward_ios</i>
          </div>
          <div class="swiper-button-prev">
            <i class="material-icons">arrow_back_ios</i>
          </div>
        </div>
        <div class="swiper-container gallery-thumbs">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(productImage,index) in galleryImageUrl" :key="index">
              <div class="img_wrapper spinner_wrapper" v-if="productImage" v-lazyload>
                <ImageSpinner class="image_spinner" />
                <img :data-url="productImage" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import Swiper from "swiper";
import "../../assets/css/swiper-slider.css";
import ImageSpinner from "../Common/ImageSpinner";
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
export default {
  name: "ProductFeedback",
  components: {
    StarRating,
    ImageSpinner
  },
  data() {
    return {
      ratingList: [],
      loading: false,
      ratingIndex: 0,
      ratingLimit: 20,
      galleryImageUrl: [],
      openProductGallery: false,
      feedBackCount: 0
    };
  },
  watch: {
    openProductGallery: function(val) {
      if (val == true) {
        this.$nextTick(() => {
          var galleryThumbs = new Swiper(".gallery-thumbs", {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true
          });
          var galleryTop = new Swiper(".gallery-top", {
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            },
            thumbs: {
              swiper: galleryThumbs
            }
          });
        });
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getFeedBackList($state) {
      this.loading = true;
      // this.$store
      //   .dispatch({
      //     type: "getOrderRating",
      //     payload: this.$route.params.orderId,
      //     limit: this.ratingLimit,
      //     index: this.ratingIndex
      //   })
        ApiCaller("https://localmall.mall91.com/", `product/rating/reviews/${this.$route.params.orderId}/${this.ratingLimit}/${this.ratingIndex}` , "get")
        .then(data => {
          this.loading = false;
          
          if (data.data.commentDTOs.length > 0) {
            this.ratingIndex += 1;
            this.ratingList.push(...data.data.commentDTOs);
            $state && $state.loaded();
            this.feedBackCount = data.data.totalRatingCount
          } else {
            this.noData = true;
            $state && $state.complete();
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    openUserProfile(XAUTHID) {
      try {
        JSBridgePlugin.showNativeProfileView(XAUTHID);
      } catch (err) {
        console.log(err);
      }
    },
    galleryPopUp(id) {
      this.openProductGallery = !this.openProductGallery;
      this.galleryImageUrl = id;
    }
  }
};
</script>
<style scoped lang="scss">
.ProductFeedback .feedback-list {
  padding: 0 15px;
}
 .prodgallery_wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid #ccccccc7;
    z-index: 999;
    background: #fff;

    .product_Gallery {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      .close_prodgallery i {
        position: absolute;
        color: #fff;
        z-index: 9;
        right: 15px;
        top: 15px;
        background: #000;
        border-radius: 50%;
        padding: 3px;
      }

      .gallery-top {
        height: 85%;
        width: 100%;

        .spinner_wrapper {
          height: 100%;
          display: flex;
          align-items: center;
        }

        .swiper-button-next:after,
        .swiper-button-prev:after {
          content: "";
        }
      }

      .swiper-slide {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
      }
    }

    .gallery-thumbs {
      height: 15%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 10px;
      background: #ccc;



      .swiper-slide {
        width: 25%;
        opacity: 0.4;
        border-radius: 10px;
        background: #fff;
        overflow: hidden;

        &.swiper-slide-thumb-active {
          opacity: 1;
          border: 2px solid #000;
        }

        img {
          height: 75px;
          width: 85px;
          -o-object-fit: contain;
          object-fit: contain;
        }
      }

    }
  }
</style>